import { render, staticRenderFns } from "./MenuColorCard.vue?vue&type=template&id=47b8d954&scoped=true&"
import script from "./MenuColorCard.vue?vue&type=script&lang=js&"
export * from "./MenuColorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8d954",
  null
  
)

export default component.exports